import { createTheme } from '@material-ui/core/styles';
import { poppinsBold, poppinsLight, poppinsRegular } from './importFonts';

export const themePrimary = (primary, isDark) => {
  return createTheme({
    palette: {
      type: isDark ? 'dark' : 'light',
      primary: {
        main: '#b48519',
      },
      secondary: {
        light: '#72727c',
        main: '#2e2757',
        contrastText: '#2e2757',
      },
      cancel: {
        main: '#D40707',
      },
      titles: {
          main: '#FFFFFF'
      },

      contrastThreshold: 3,
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: [
        'PoppinsRegular',
        'PoppinsBold',
        'PoppinsLight'
      ].join(','),
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [poppinsLight, poppinsBold, poppinsRegular],
        },
      },
      MuiButton: {
        root: {
          height: 40,
          width: 110,
          borderRadius: 20,
          // fontSize: 8,
          textTransform: "inherit",
          "&.MuiButton-outlinedSecondary": {
            color: "#b98919"
          },
          "&.MuiButton-containedSecondary": {
            color: "#fff"
          },
          "&.MuiButton-contained": {
            boxShadow: "none"
          },
          "&.MuiButton-outlined": {
            borderWidth: 2
          }
        },
        defaultProps: {
          allowFontScaling: false,
        },
        
      },
      MuiBottomNavigationAction:{
        root: {
          '&.Mui-selected': { 
            '& .MuiBottomNavigationAction-label': { 
              fontSize: '0.6rem', 
            },
          },
        },
        label: {
          fontSize: 12,
          }
      },
      MuiIcon: {
        root: {
          fontSize: 24
        },
        defaultProps: {
          allowFontScaling: false,
        },
      },
      MuiIconButton: {
        root: {
          fontSize: 20,
        },
        defaultProps: {
          allowFontScaling: false,
        },
      },
      MuiTypography: {
        root: {
          fontSize: 10,
        },
        defaultProps: {
          allowFontScaling: false,
        },
      },
    },
  })
}